export const DASHBOARD_APP_NAME = 'Home';
// order management console and media ingest console refer to the same application. We need to support both names for now.
export const OKTA_AUTH_DEFAULT_ACCESS_APPS = ['Order Management Console', 'C3 Linear Monitoring', 'Media Ingest Console'];
export const DEFAULT_MIC_ROLE = 'omc-simplified-viewer';
// TODO: Need to be populated from API response.
export const DIRECT_ACCESS_APP_RELATED_ROLES = {
    'C3 Linear Monitoring': ['c3-scheduler'],
    'Media Ingest Console': ['omc-developer', 'omc-viewer', 'omc-simplified-viewer', 'omc-update-access'],
    'Order Management Console': ['omc-developer', 'omc-viewer', 'omc-simplified-viewer', 'omc-update-access']
};
export const DIRECT_ACCESS_DEFAULT_PERMISSION = {
    uuid: 'xxxx-xxxx-xxxx-xxxx-xxxx',
    applications: [],
    permissions: []
};
export const DIRECT_ACCESS_DEFAULT_ROLE = {
    id: 9999999,
    uuid: 'xxxx-xxxx-xxxx-xxxx-xxxx',
    name: null,
    createdDate: null,
    modifiedDate: null,
    lastModifiedBy: null,
    roles: [
        {
            id: 9999999,
            name: DEFAULT_MIC_ROLE,
            userType: undefined,
            permissions: [],
            applicationAdminPrivileges: undefined,
            users: undefined
        }
    ]
};
//# sourceMappingURL=index.js.map